import { axiosInstance } from ".";

const getPromotionRequestsList = async (params) =>
  await axiosInstance.get("/promotion_requests", { params });

const editPromotionRequest = async ({ data, id }) =>
  await axiosInstance.patch(`/promotion_requests/${id}`, data);

export { getPromotionRequestsList, editPromotionRequest };
